export default __webpack_public_path__ + "static/media/kitchen4-afterF-1440w.a299c711.png";